import React from 'react'
import HeroTextPane from './HeroTextPane'
import './style.css'

const AppsHeroSection = ({ showErrorNotification }) => (
  <div className="apps-hero-section">
    <div className="apps-hero-section-background" />
    <HeroTextPane
      className="apps-hero-section-text"
      showErrorNotification={showErrorNotification}
    />
  </div>
)

export default AppsHeroSection
